import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class EquitySearchUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(data) {
        return await this.Repo.getEqSearch(data);
    }
}
export default EquitySearchUseCase;
